import { render, staticRenderFns } from "./DonorInfo.vue?vue&type=template&id=0100f5c1&scoped=true&"
import script from "./DonorInfo.vue?vue&type=script&lang=js&"
export * from "./DonorInfo.vue?vue&type=script&lang=js&"
import style0 from "./DonorInfo.vue?vue&type=style&index=0&id=0100f5c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100f5c1",
  null
  
)

export default component.exports